var map = {
	"./cube-run/1.webp": 6115,
	"./forest-hero/1.webp": 7398,
	"./forest-hero/2.webp": 3454,
	"./forest-hero/3.webp": 7636,
	"./forest-hero/4.webp": 7962,
	"./forest-hero/5.webp": 5537,
	"./forest-hero/6.webp": 5289,
	"./forest-hero/7.webp": 1249,
	"./mc/1.webp": 8414,
	"./mc/2.webp": 2219,
	"./memory-game/1.webp": 6912,
	"./msb/1.webp": 4563,
	"./msb/2.webp": 8701,
	"./msb/3.webp": 2538,
	"./msb/4.webp": 7685,
	"./msb/5.webp": 3293,
	"./msb/6.webp": 1643,
	"./msb/7.webp": 5433,
	"./msb/8.webp": 1480,
	"./msb/9.webp": 198,
	"./pyra-jump/1.webp": 9292,
	"./pyra-jump/2.webp": 8656,
	"./roll-ball/1.webp": 1251,
	"./roll-ball/2.webp": 3679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9242;